<template>
	<div class="container">
		<div v-for="q in quest" :key="q.id">
			<MCUB @add:response="addResponse" v-if="q.type == 'uni'" :items="q.items" :title="q.title" :id="q.id" />
			<MCBB @add:response="addResponse" v-else-if="q.type == 'bi'" :items="q.items" :title="q.title" :id="q.id" />
			<TB @add:response="addResponse" v-else-if="q.type == 'text'" :items="q.items" :title="q.title" />
			<SB @add:response="addResponse" v-else-if="q.type == 'special'" :items="q.items" :title="q.title" />
			<DSP @add:response="addResponse" v-else-if="q.type == 'dsp'" :items="q.items" :dsp="Veranstaltung.dsp" />
			<MWP @add:response="addResponse" v-if="q.type == 'matwis-p'" :items="q.items" :title="q.title" :id="q.id" :rowTitle="q.rowTitle" />
			<AGE @add:response="addResponse" v-else-if="q.type == 'age'" :item="q.items[0]" />
		</div>
		<button @click.once="endQuest">{{ sendButton[lang] }}</button>
	</div>
</template>

<script>
import MCUB from "@/components/blocks/mc-uni-block.vue";
import MCBB from "@/components/blocks/mc-bi-block.vue";
import TB from "@/components/blocks/txt-block.vue";
import SB from "@/components/blocks/special-block.vue";
import DSP from "@/components/blocks/dsp-block.vue";
import MWP from "@/components/blocks/matwis-p.vue";
import AGE from "@/components/items/age.vue";
import COMM from "@/assets/js/communication.js";
import { mapGetters } from "vuex";

export default {
	components: {
		MCUB,
		MCBB,
		TB,
		SB,
		DSP,
		MWP,
		AGE,
	},
	props: {
		quest: Array,
		state: String,
		Participant: Object,
		Veranstaltung: Object,
	},
	methods: {
		addResponse(response) {
			// this.$emit('add:response', response);
			this.Participant.response[response.id - 1] = response.value;
		},
		async endQuest() {
			let postResponse = await COMM.sendEva(this.Participant);
			console.log(postResponse);
			this.$emit("state:end");
		},
	},
	computed: mapGetters(["sendButton", "lang"]),
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	padding: 0 2%;
}
button {
	align-self: center;
	margin: 1.5rem 0;
}
</style>
